import UserMain from "@/views/users/views/UsersMain.vue";
import ListRoute from "@/views/users/views/list/router/list.route";

const routes = [
  {
    path: "/users",
    name: "users",
    redirect: { name: "users-list" },
    meta: { module: 1},
    component: UserMain,
    children: [...ListRoute],
  },
];

export default routes;
